/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconChevronRight/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconChevronRight({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconChevronRight",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "#353535",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconChevronRight.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZJ71g7': alignSelf,'--mt-2-ZJ71g7': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZJ71g7': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZJ71g7': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZJ71g7': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZJ71g7': opacity,'--w-10-ZJ71g7': typeof width === 'number' ? `${width}px` : width,'--h-11-ZJ71g7': typeof height === 'number' ? `${height}px` : height,'--f-12-ZJ71g7': fill,'--a-7-ZJ71g7': isAnimated ? animation : "none",'--sd-8-ZJ71g7': isAnimated ? strokeDashoffset : 0,'--sd-9-ZJ71g7': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconChevronRight.SvgPath"
  data-view-path={viewPath}
 d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}